class CloudinaryUploader {
  constructor() {
    this.uploadPreset = "ml_default";
    this.cloudName = "dfbppdozx";
    this.uploadedUrls = [];
    this.init();
  }

  init() {
    // Find all file upload elements with the specific class
    const uploadButtons = document.querySelectorAll(".js-simple-image-upload");
    uploadButtons.forEach((button) => {
      this.bindEvents(button);
    });
  }

  bindEvents(uploadButton) {
    const targetId = uploadButton.getAttribute("data-target");
    const fileInput = document.getElementById(targetId);
    const textSpan = document.querySelector(
      `[data-target="${targetId}"].js-input-image-text`
    );

    if (!fileInput || !textSpan) return;

    // Handle file selection
    fileInput.addEventListener("change", (e) => {
      const files = Array.from(e.target.files);
      if (files.length > 0) {
        this.handleFileUpload(files, textSpan, uploadButton);
      }
    });
  }

  async handleFileUpload(files, textSpan, uploadButton) {
    try {
      this.updateUI(textSpan, uploadButton, "Uploading...", true);
      this.stateSubmitButton(true);

      const uploadPromises = files.map((file) => this.uploadToCloudinary(file));
      const uploadedUrls = await Promise.all(uploadPromises);

      // Store uploaded URLs
      this.uploadedUrls = [...this.uploadedUrls, ...uploadedUrls];

      // Update UI to show success
      const fileText =
        files.length === 1
          ? "1 file uploaded"
          : `${files.length} files uploaded`;
      this.updateUI(textSpan, uploadButton, fileText, false);

      // Add hidden inputs to form with the URLs
      this.addUrlsToForm(uploadedUrls);

      // Show uploaded files list
      this.showUploadedFiles(uploadedUrls, textSpan);

      this.stateSubmitButton(false);
      console.log("All files uploaded successfully:", uploadedUrls);
    } catch (error) {
      console.error("Upload failed:", error);
      this.updateUI(textSpan, uploadButton, "Upload failed. Try again.", false);
      this.stateSubmitButton(false);
    }
  }

  uploadToCloudinary(file) {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("upload_preset", this.uploadPreset);

      fetch(`https://api.cloudinary.com/v1_1/${this.cloudName}/image/upload`, {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.url) {
            console.log(data.url, "uploaded successfully");
            resolve(data.url);
          } else {
            throw new Error(
              "Upload failed: " + (data.error?.message || "Unknown error")
            );
          }
        })
        .catch((error) => {
          console.error("Cloudinary upload error:", error);
          reject(error);
        });
    });
  }

  updateUI(textSpan, uploadButton, text, isLoading) {
    if (textSpan) {
      textSpan.textContent = text;
    }

    if (uploadButton) {
      if (isLoading) {
        uploadButton.style.opacity = "0.6";
        uploadButton.style.pointerEvents = "none";
      } else {
        uploadButton.style.opacity = "1";
        uploadButton.style.pointerEvents = "auto";
      }
    }
  }

  addUrlsToForm(urls) {
    // Find the contact form
    const form = document.querySelector('form[action*="contact"]');
    if (!form) return;

    // Remove any existing hidden inputs for this batch
    const existingInputs = form.querySelectorAll(
      'input[name^="uploaded_files["]'
    );
    existingInputs.forEach((input) => input.remove());

    // Remove existing JSON input
    const existingJsonInput = form.querySelector(
      'input[name="uploaded_files_json"]'
    );
    if (existingJsonInput) {
      existingJsonInput.remove();
    }

    // Add new hidden input with all uploaded URLs (current + previous)
    this.uploadedUrls.forEach((url, index) => {
      const hiddenInput = document.createElement("input");
      hiddenInput.type = "hidden";
      hiddenInput.name = `uploaded_files[${index}]`;
      hiddenInput.value = url;
      form.appendChild(hiddenInput);
    });

    // Also add a single input with all URLs as JSON for easier processing
    const jsonInput = document.createElement("input");
    jsonInput.type = "hidden";
    jsonInput.name = "uploaded_files_json";
    jsonInput.value = JSON.stringify(this.uploadedUrls);
    form.appendChild(jsonInput);
  }

  // Method to get all uploaded URLs (can be used by other scripts)
  getUploadedUrls() {
    return this.uploadedUrls;
  }

  // Method to show uploaded files visually
  showUploadedFiles(urls, textSpan) {
    const container =
      textSpan.closest(".form-field, .flex") || textSpan.parentElement;

    // Remove existing upload list
    const existingList = container.querySelector(".uploaded-files-list");
    if (existingList) {
      existingList.remove();
    }

    if (urls.length > 0) {
      const listDiv = document.createElement("div");
      listDiv.className = "uploaded-files-list mt-2";
      listDiv.innerHTML = `
                <div class="text-xs text-green-600 font-medium mb-1">
                    ✓ ${urls.length} file${
        urls.length > 1 ? "s" : ""
      } uploaded successfully
                </div>
                <div class="space-y-1">
                    ${urls
                      .map(
                        (url, index) => `
                        <div class="text-xs text-gray-600 flex items-center">
                            <span class="w-2 h-2 bg-green-500 rounded-full mr-2"></span>
                            File ${index + 1} uploaded
                        </div>
                    `
                      )
                      .join("")}
                </div>
            `;
      container.appendChild(listDiv);
    }
  }

  // Method to clear uploaded files
  clearUploadedFiles() {
    this.uploadedUrls = [];
    const form = document.querySelector('form[action*="contact"]');
    if (form) {
      const hiddenInputs = form.querySelectorAll(
        'input[name^="uploaded_files"]'
      );
      hiddenInputs.forEach((input) => input.remove());

      // Clear visual indicators
      const uploadLists = form.querySelectorAll(".uploaded-files-list");
      uploadLists.forEach((list) => list.remove());
    }
  }

  stateSubmitButton(state) {
    const form = document.querySelector('form[action*="contact"]');
    if (!form) return;
    const submitButton = form.querySelector('button[type="submit"], input[type="submit"]');
    if (submitButton) {
      submitButton.disabled = state;
    }
  }
}

// Initialize only once when DOM is ready
function initializeUploader() {
  new CloudinaryUploader();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeUploader);
} else {
  // DOM is already loaded
  initializeUploader();
}

class ImageUpload extends HTMLElement {
  constructor() {
    super();
    this.uploadPreset = "ml_default";
    this.cloudName = "dfbppdozx";
    this.input = null;
    this.imagePreview = null;
    this.removeBtn = null;
    this.uploadPlaceholder = null;
    this.hiddenInput = null;
    this.loadingIndicator = null;
  }

  connectedCallback() {
    this.input = this.querySelector(".js-image-upload-input");
    this.imagePreview = this.querySelector(".js-image-preview");
    this.removeBtn = this.querySelector(".js-remove-image-btn");
    this.uploadPlaceholder = this.querySelector(".js-upload-placeholder");
    this.hiddenInput = this.querySelector(".js-image-upload-input-hidden");
    this.loadingIndicator = this.querySelector(".js-upload-loading-indicator");

    if (this.input) {
      this.input.addEventListener("input", this.uploadFile.bind(this));
    }
    if (this.removeBtn) {
      this.removeBtn.addEventListener("click", this.removeImage.bind(this));
    }
  }

  setLoading(isLoading) {
    if (this.loadingIndicator) {
      this.loadingIndicator.style.display = isLoading ? "block" : "none";
    }
    if (this.input) {
      this.input.disabled = isLoading;
    }
    if (this.removeBtn) {
      this.removeBtn.disabled = isLoading;
    }
  }

  uploadFile() {
    const file = this.input && this.input.files ? this.input.files[0] : null;
    if (!file) return;

    // File size validation (10MB = 10,485,760 bytes)
    const MAX_SIZE = 10485760;
    if (file.size > MAX_SIZE) {
      this.handleUploadError("File size too large. Maximum allowed is 10MB.");
      return;
    }

    this.setLoading(true);
    if (this.uploadPlaceholder) this.uploadPlaceholder.style.display = "none";
    if (this.imagePreview) this.imagePreview.style.display = "none";
    if (this.removeBtn) {
      this.removeBtn.style.display = "none";
      this.removeBtn.style.opacity = "0";
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", this.uploadPreset);

    fetch(`https://api.cloudinary.com/v1_1/${this.cloudName}/image/upload`, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.setLoading(false);
        if (data.url) {
          if (this.imagePreview) {
            const previewImg =
              this.imagePreview.querySelector(".js-preview-image");
            if (previewImg) {
              previewImg.src = data.url;
              this.imagePreview.style.display = "flex";
            }
          }
          if (this.removeBtn) {
            this.removeBtn.style.display = "flex";
            this.removeBtn.style.opacity = "1";
          }
          this.updateInputValue(data.url);
        } else {
          this.handleUploadError(data.error?.message || "Unknown error");
        }
      })
      .catch((error) => {
        this.setLoading(false);
        this.handleUploadError(
          error.message || "Upload failed. Please try again."
        );
      });
  }

  updateInputValue(url) {
    if (this.hiddenInput) {
      this.hiddenInput.value = url;
    }
  }

  removeImage(e) {
    if (e) e.preventDefault();
    if (this.input) this.input.value = "";
    if (this.hiddenInput) this.hiddenInput.value = "";
    if (this.imagePreview) this.imagePreview.style.display = "none";
    if (this.uploadPlaceholder) this.uploadPlaceholder.style.display = "flex";
    if (this.removeBtn) {
      this.removeBtn.style.display = "none";
      this.removeBtn.style.opacity = "0";
    }
  }

  handleUploadError(message) {
    this.removeImage();
    if (this.uploadPlaceholder) this.uploadPlaceholder.style.display = "flex";
    if (this.removeBtn) {
      this.removeBtn.style.display = "none";
      this.removeBtn.style.opacity = "0";
    }
    alert("Upload failed. " + message);
  }
}

customElements.define("image-upload", ImageUpload);
